(function() {
    'use strict';
    Odigeo.UIElements.fade = {};
    Odigeo.UIElements.fade.enhance = function(wrapper, newOptions) {
        var $wrapper = (wrapper instanceof $) ? wrapper : $(wrapper);
        var options = {
            fadeInTimes: {
                duration: 2,
                delay: 0,
            },
            fadeOutTimes: {
                duration: 2,
                delay: 3,
            },
            events: {
            },
        };
        var _showElement;
        var _hideElement;
        var _fadeElement;
        var _toggle;
        var _generateCssAnimation;
        var _triggerEvent;

        // wrapper doesn't exist
        if ($wrapper.length === 0) {
            return false;
        }

        if ($wrapper.attr('data-skip-enhance') === 'true') {
            return $wrapper;
        }

        $wrapper.attr({'data-skip-enhance': true});
        options = Odigeo._.extend(options, newOptions);

        /**
         * Show the element that contains $wrapper
         */
        _showElement = function() {
            var waitingTime = (options.fadeInTimes.duration + options.fadeInTimes.delay) * 1000;
            $wrapper.removeClass('hidden od-fade-out')
                .css(_generateCssAnimation('duration', options.fadeInTimes.duration))
                .css(_generateCssAnimation('delay', options.fadeInTimes.delay))
                .addClass('od-fade-in');
            _triggerEvent('show', waitingTime);
        };

        /**
         * Hide the element that contains $wrapper
         */
        _hideElement = function() {
            var waitingTime = (options.fadeOutTimes.duration + options.fadeOutTimes.delay) * 1000;
            $wrapper.removeClass('od-fade-in')
                .css(_generateCssAnimation('duration', options.fadeOutTimes.duration))
                .css(_generateCssAnimation('delay', options.fadeOutTimes.delay))
                .addClass('od-fade-out');
            Odigeo._.delay(function() {
                $wrapper.addClass('hidden');
            }, waitingTime);
            _triggerEvent('hide', waitingTime);
        };

        _fadeElement = function() {
            var waitingTime = (options.fadeInTimes.duration + options.fadeInTimes.delay) * 1000;
            _showElement();
            Odigeo._.delay(_hideElement, waitingTime);
        };

        _toggle = function() {
            if ($wrapper.hasClass('od-fade-out')) {
                _showElement();
            } else {
                _hideElement();
            }
        };

        _triggerEvent = function(eventType, delay) {
            var ev = options.events[eventType];

            if (Odigeo._.isString(ev) && !Odigeo._.isEmpty(ev)) {
                Odigeo._.delay(Odigeo._.bind($wrapper.trigger, $wrapper), delay, ev);
            }
        };

        _generateCssAnimation = function(action, time) {
            var data = {};
            var timeCSS = time + 's';
            data['-webkit-animation-' + action] = timeCSS;
            data['-moz-animation-' + action] = timeCSS;
            data['animation-' + action] = timeCSS;
            return data;
        };

        $wrapper.on('showElement', _showElement).on('hideElement', _hideElement).on('fadeElement', _fadeElement).on('toggle', _toggle);

        return $wrapper;
    };

    Odigeo.UIElements.fade.unbind = function($wrapper) {
        $wrapper.off('showElement hideElement fadeElement toggle');

        return $wrapper;
    };
})();
